import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {ShopsBrowserComponent} from './shops-wrapper/shops/components/shops-browser/shops-browser.component';
import {ProductsBrowserComponent} from './products/products-browser/products-browser.component';
import {CompetitorShopsResolver, EditableShopResolver} from './shops-wrapper/shops';

import {ProductPageComponent} from './products/product-page/product-page.component';
import {ProductPageResolver} from './products/services/product-resolver.service';

import {ShopPageComponent} from './shops-wrapper/shops/components/shop-page/shop-page.component';
import {ShopCreateComponent} from './shops-wrapper/shops/components/shop-create/shop-create.component';

import {ProfilePermissions} from '../core/models/profile.models';
import {FeaturesBrowserComponent} from './features/features-browser/features-browser.component';
import {FeaturesCreateComponent} from './features/features-create/features-create.component';
import {FeaturesEditComponent} from './features/features-edit/features-edit.component';
import {FeaturesPageComponent} from './features/features-page/features-page.component';
import {ShopsDetailsWrapperComponent} from 'app/domain/shops-wrapper/shops-details-wrapper/shops-wrapper.component';
import {ShopFloorplanPageComponent} from 'app/domain/shops-wrapper/shops/components/shop-floorplan-page/shop-floorplan-page.component';
import {SettingsComponent} from 'app/domain/settings/settings/settings.component';
import {ShelvesBrowserComponent} from 'app/domain/settings/shelves-browser/shelves-browser.component';
import {ShelfCreateComponent} from 'app/domain/settings/shelf-create/shelf-create.component';
import {ShelfPageComponent} from 'app/domain/settings/shelf-page/shelf-page.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'articles',
        pathMatch: 'full',
        data: { breadcrumb: '' },
    },
    {
        path: 'articles',
        data: { auth: ProfilePermissions.PRODUCTS, breadcrumb: 'artykuły' },
        children: [
            {
                path: '',
                component: ProductsBrowserComponent,
                data: { breadcrumb: '' },
            },
            {
                path: 'add',
                component: ProductPageComponent,
                data: { breadcrumb: 'dodać' },
            },
            {
                path: 'add/:id',
                component: ProductPageComponent,
                data: { breadcrumb: 'karta artykułu' },
                resolve: {
                    product: ProductPageResolver,
                },
            },
        ],
    },
    {
        path: 'settings',
        data: {breadcrumb: 'ustawienia'},
        component: SettingsComponent,
        children: [
            {
                path: '',
                redirectTo: 'features',
                pathMatch: 'full'
            },
            {
                path: 'shelves',
                data: {breadcrumb: 'regały'},
                children: [
                    {
                        path: '',
                        component: ShelvesBrowserComponent,
                        data: {breadcrumb: 'regały'},
                    },
                    {
                        path: 'add',
                        component: ShelfCreateComponent,
                        data: {breadcrumb: 'nowy regał'},
                    },
                    {
                        path: 'add/:id',
                        component: ShelfCreateComponent,
                        data: {breadcrumb: 'edycja regału'}
                    },
                    {
                        path: ':id',
                        component: ShelfPageComponent,
                        data: {breadcrumb: 'szczegóły regału'}
                    }
                ]
            },
            {
                path: 'features',
                data: {breadcrumb: 'cechy'},
                children: [
                    {
                        path: '',
                        component: FeaturesBrowserComponent,
                        data: {breadcrumb: ''},
                    },
                    {
                        path: 'add',
                        component: FeaturesCreateComponent,
                        data: {breadcrumb: 'nowa cecha'},
                    },
                    {
                        path: 'add/:id',
                        component: FeaturesEditComponent,
                        data: {breadcrumb: 'edycja cechy'}
                    },
                    {
                        path: 'details/:id',
                        component: FeaturesPageComponent,
                        data: {breadcrumb: 'szczegóły cechy'}
                    }
                ],
            }
        ]
    },
    {
        path: 'store/:id',
        component: ShopsDetailsWrapperComponent,
        data: { auth: ProfilePermissions.STORES, breadcrumb: 'placówki' },
        children: [
            { path: '', redirectTo: 'details', pathMatch: 'full' },
            {
                path: 'details',
                component: ShopPageComponent,
                data: { breadcrumb: 'podgląd placówki' },
                resolve: {
                    shop: EditableShopResolver,
                    competitors: CompetitorShopsResolver,
                },
            },
            {
                path: 'floorplan',
                component: ShopFloorplanPageComponent,
                data: { breadcrumb: 'podgląd floorplanu placówki' },
            }
        ]
    },
    {
        path: 'stores',
        data: { auth: ProfilePermissions.STORES, breadcrumb: 'placówki' },
        children: [
            { path: '', redirectTo: 'all', pathMatch: 'full' },
            {
                path: 'all',
                component: ShopsBrowserComponent,
                data: { breadcrumb: 'all' },
            },
            {
                path: 'new-store',
                component: ShopCreateComponent,
                data: { breadcrumb: 'nowa placówka' },
            },
            {
                path: 'edition-store/:id',
                component: ShopCreateComponent,
                data: { breadcrumb: 'edycja placówki' },
            },
            {
                path: 'store-details/:id',
                component: ShopPageComponent,
                data: { breadcrumb: 'podgląd placówki' },
                resolve: {
                    shop: EditableShopResolver,
                    competitors: CompetitorShopsResolver,
                },
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class DomainRoutingModule { }
